/**
 * Component added to the scene to store settings.
 */
class SettingsComponent {
    constructor({ disableFrameStacking }) {
        this.typeId = SettingsComponent.id;
        this.serializable = false;
        this.doStoreInSnapshot = false;
        this.disableFrameStacking = false;
        this.disableFrameStacking = disableFrameStacking;
    }
    eq() {
        return true;
    }
}
SettingsComponent.id = 3001;
export default SettingsComponent;
//# sourceMappingURL=SettingsComponent.js.map